import React from "react";
import { DonationWrapper } from "./Donation.styles";
import DonationSetupSection from "./DonationSetupSection";
import DonationPriceSection from "./PriceSection";
import DonationAdvanceSection from "./AdvanceSection";
import { inject, observer } from "mobx-react";
import {
  ItemContainer,
  MainContent,
  MembershipTierDetails,
  ProductDetailWrapper,
  ProductOptionWrapper,
} from "../../../shared/styles";
import { DonationStore } from "../../../shared/store";
import { ItemHeader } from "../../../shared/components";
import DonationAdvertisingBlock from "../../../shared/components/DonationAdvertisingBlock";
import {
  DonationPricingPageInputsModel,
  ItemDetailInputModel,
} from "../../../shared/models";

type IProps = {
  donationStore?: DonationStore;
};

@inject("donationStore")
@observer
class PricingPage extends React.Component<IProps> {
  render() {
    return (
      <ProductDetailWrapper>
        <ProductOptionWrapper>
          <DonationWrapper>
            <MainContent className="main-content">
              {/* Left Block */}
              <div className="flex-auto-grow">
                <ItemContainer
                  padding="0px 25px 0px 0px"
                  className="float-aside"
                >
                  <ItemHeader header={"Donation Pricing"} />
                  <MembershipTierDetails>
                    {/* Setup Section */}
                    <DonationSetupSection />
                    {/* Price Section */}
                    <DonationPriceSection />
                    {/* Advance Section */}
                    <DonationAdvanceSection />
                  </MembershipTierDetails>
                </ItemContainer>
              </div>
              {/* Advertising Block */}
              <DonationAdvertisingBlock
                detailSection={
                  this.props.donationStore?.detailPage ||
                  new ItemDetailInputModel()
                }
                pricing={
                  this.props.donationStore?.pricingPageData ||
                  new DonationPricingPageInputsModel()
                }
                isPreview={true}
                scrollToField={this.props.donationStore?.scrollToField}
              />
            </MainContent>
          </DonationWrapper>
        </ProductOptionWrapper>
      </ProductDetailWrapper>
    );
  }
}

export default PricingPage;
